import React, { Component } from 'react'
import PropTypes from 'prop-types'
import buildUrl from '../../utils/apiHelpers'
import TableBody from 'components/Table/TableBody'
import TableHead from 'components/Table/TableHead'
import Table from '@material-ui/core/Table'
import TableContainer from '@material-ui/core/TableContainer'

class ListingsTable extends Component {
  constructor (props) {
    super(props)
    this.state = {
      gridTemplateColumns: '190px minmax(0, 4fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1.5fr) 150px minmax(0, 3.5fr)',
      page: 1,
      selectedSortBy: 'Created on',
      sortByCreatedOn: 'DESC',
      sortByPrice: undefined,
      isLoadingMoreListings: false
    }

    this.handleSortByCreatedOn = this.handleSortByCreatedOn.bind(this)
    this.handleSortByPrice = this.handleSortByPrice.bind(this)
    this.handlePaginatedDisplay = this.handlePaginatedDisplay.bind(this)
  }

  componentDidUpdate (prevProps) {
    if (prevProps.selectedFilter !== this.props.selectedFilter) {
      this.setState({ page: 1 })
    }
    if (prevProps.listings.length !== this.props.listings.length) {
      this.setState({ isLoadingMoreListings: false })
    }
  }

  getHeaders () {
    return (
      [
        { title: 'Reference' },
        { title: 'Title' },
        { title: 'SKU' },
        { title: 'Price', onClick: this.handleSortByPrice },
        { title: 'Created on', onClick: this.handleSortByCreatedOn },
        { title: 'Delivery size' },
        { title: 'Status' }
      ]
    )
  }

  handleSortByPrice () {
    const sortByPrice = this.state.sortByPrice === 'DESC' ? 'ASC' : 'DESC'
    this.setState({ selectedSortBy: 'Price', sortByPrice: sortByPrice })
  }

  handleSortByCreatedOn () {
    const sortByCreatedOn = this.state.sortByCreatedOn === 'DESC' ? 'ASC' : 'DESC'
    this.setState({ selectedSortBy: 'Created on', sortByCreatedOn: sortByCreatedOn })
  }

  listingsSortedByPrice () {
    if (this.state.sortByPrice === 'DESC') {
      return this.props.listings.slice().sort((a, b) => a.price > b.price ? -1 : 1)
    }
    return this.props.listings.slice().sort((a, b) => a.price > b.price ? 1 : -1)
  }

  listingsSortedByCreatedOn () {
    if (this.state.sortByCreatedOn === 'DESC') {
      return this.props.listings
    }
    return this.props.listings.slice().reverse()
  }

  renderSortedListings () {
    if (this.state.selectedSortBy === 'Price') {
      return this.listingsSortedByPrice()
    }
    return this.listingsSortedByCreatedOn()
  }

  importListingsMessage () {
    if (this.props.p2pSeller) return
    return (
      <>
        or <a href={buildUrl('/listings/import')} className='underline' style={{ display: 'inline-block', margin: '0px 5px' }}> importing your listings </a>
        from other websites.
      </>
    )
  }

  noListingsMessage () {
    return (
      <tbody className='text-center'>
        <tr style={{ fontSize: '20px' }}>
          <td className='pt-32'>You have no listings yet</td>
        </tr>
        <tr>
          <td className='pt-10'>
            Brings your items to Vinterior by
            <a href={buildUrl('/listings/new')} className='underline' style={{ display: 'inline-block', margin: '0px 5px' }}> adding a new listing </a>
            {this.importListingsMessage()}
          </td>
        </tr>
      </tbody>
    )
  }

  renderTableBody () {
    const listingsToRender = this.renderSortedListings()

    return (
      <TableBody
        listings={listingsToRender}
        gridTemplateColumns={this.state.gridTemplateColumns}
        isLoading={this.props.isLoading}
        selectedFilter={this.props.selectedFilter}
        canBoostListings={this.props.canBoostListings}
      />
    )
  }

  renderNoSearchResultsFound () {
    return (
      <tbody>
        <tr className='text-center'>
          <td className='pt-16'>Sorry, we found no matching listings</td>
        </tr>
      </tbody>
    )
  }

  renderNoFilteredListingsFound () {
    if (this.props.selectedFilter === 'Interest from buyers') {
      return (
        <tbody>
          <tr className='text-center'>
            <td className='pt-16'>Buyers haven't added your listings to their cart or wishlist recently.</td>
          </tr>
        </tbody>
      )
    } else {
      return (
        <tbody>
          <tr className='text-center'>
            <td className='pt-16'>You don't have any listings with this status</td>
          </tr>
        </tbody>
      )
    }
  }

  renderNoPublishedListingsMessage () {
    return (
      <tbody className='text-center'>
        <tr style={{ fontSize: '20px' }}>
          <td className='pt-32'>You don't have any published listings</td>
        </tr>
        <tr>
          <td className='pt-10'>
            If you have not done so, you can
            <a href={buildUrl('/listings/new')} className='underline' style={{ display: 'inline-block', margin: '0px 5px' }}> create a listing </a>
            {this.importListingsMessage()}
          </td>
        </tr>
      </tbody>
    )
  }

  renderTableData () {
    if (this.props.searchQuery !== '' && this.props.listings.length === 0 && !this.props.isLoading) {
      return this.renderNoSearchResultsFound()
    } else if (this.props.listings.length === 0 && this.props.selectedFilter === 'Published' && !this.props.isLoading) {
      return this.renderNoPublishedListingsMessage()
    } else if (this.props.noFilteredListings && !this.props.isLoading) {
      return this.renderNoFilteredListingsFound()
    } else {
      return this.renderTableBody()
    }
  }

  // The main listings endpoint reports hasMore (its count is capped, so the
  // loaded-everything comparison against nbOfListings can't be trusted). The
  // filter endpoints don't report it yet - fall back to the count comparison.
  hasMoreListings () {
    if (this.props.hasMore !== undefined) return this.props.hasMore
    return this.props.listings.length !== this.props.nbOfListings
  }

  renderLoadMoreButton () {
    return (
      <div className='text-center mt-32'>
        {this.state.isLoadingMoreListings &&
          <div className='text-center my-16 mx-16'>
            <div className='vsd-lds-ring'>
              <div />
              <div />
              <div />
              <div />
            </div>
          </div>}
        {(!this.hasMoreListings() || this.state.isLoadingMoreListings)
          ? ('')
          : (
            <button onClick={this.handlePaginatedDisplay} className='vsd-button__outlined'>
              Load more listings
            </button>)}
      </div>
    )
  }

  handlePaginatedDisplay () {
    this.props.loadMoreListings(this.state.page + 1, this.props.perPage)
    this.setState({ isLoadingMoreListings: true, page: this.state.page + 1 })
  }

  renderErrorMessage () {
    return (
      <tbody className='text-center'>
        <tr style={{ fontSize: '20px' }}>
          <td className='pt-32'>
            Oops something went wrong, please reload the page or contact us at sellersupport@vinterior.co if the error persists.
          </td>
        </tr>
      </tbody>
    )
  }

  render () {
    const { success, nbOfListings, selectedFilter, isLoading, searchQuery, noFilteredListings } = this.props
    return (
      <TableContainer style={{ width: '100%' }}>
        <Table aria-label='simple table'>
          <TableHead
            headers={this.getHeaders()}
            currentSelected={this.state.selectedSortBy}
            gridTemplateColumns={this.state.gridTemplateColumns}
            className='[@media(max-width:992px)]:hidden'
          />
          {!success && this.renderErrorMessage()}
          {success && (nbOfListings === 0 && selectedFilter === 'All' && !isLoading && !searchQuery ? this.noListingsMessage() : this.renderTableData())}
        </Table>
        {isLoading || noFilteredListings ? null : this.renderLoadMoreButton()}
      </TableContainer>
    )
  }
}

ListingsTable.propTypes = {
  listings: PropTypes.array,
  nbOfListings: PropTypes.number,
  hasMore: PropTypes.bool,
  isLoading: PropTypes.bool,
  noFilteredListings: PropTypes.bool,
  selectedFilter: PropTypes.string,
  loadMoreListings: PropTypes.func,
  perPage: PropTypes.number,
  success: PropTypes.bool,
  searchQuery: PropTypes.string,
  p2pSeller: PropTypes.bool,
  canBoostListings: PropTypes.bool
}

export default ListingsTable
